import React from 'react';

import type { BrandLogoProps } from './BrandLogo.types';

import { Logo } from '@/components/ui/Logo';

/**
 * The header and drawer lockup: the drawn Dō mark beside a white "Dō".
 *
 * The chrome's plain brand. The sidebar's `SidebarBrand` sets the name in the
 * bloom gradient instead. Mobile's `BrandLogo` is its port.
 *
 * @example
 * ```tsx
 * <BrandLogo />
 * ```
 */
export function BrandLogo({
  name = 'Dō',
  mark,
}: BrandLogoProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-2">
      {/* The name beside it speaks for the mark */}
      {mark ?? <Logo size={32} decorative />}
      <span className="font-display text-body-lg font-bold text-neutral-50">
        {name}
      </span>
    </div>
  );
}

export default BrandLogo;
